import { Dialog } from "./common";

export const action = "select-group-type";

export class DialogBox extends Dialog {
	open(action) {
		this.$action = action.groupAction;
		Dialog.prototype.open.call(this);
	}
	$show(box) {
		const labels = webix.i18n.spreadsheet.labels;
		box.getHead().getChildViews()[0].setHTML(labels[this.$action]);
	}
	okClick() {
		const type = this.$dialog.getBody().elements["type"].getValue();
		this.close();
		this.view.callEvent("onCommand", [{ id: this.$action, group: type }]);
	}
	$init() {
		const actions = webix.i18n.spreadsheet.actions;

		return {
			view: "ssheet-dialog",
			position: "center",
			width: 300,
			move: true,
			body: {
				view: "radio",
				name: "type",
				vertical: true,
				value: "row",
				optionHeight: webix.skin.$active.inputHeight,
				options: [
					{ id: "row", value: actions["row"] },
					{ id: "column", value: actions["column"] },
				],
			},
			on: {
				onSaveClick: () => this.okClick(),
				onCancelClick: () => this.close(),
			},
		};
	}
}
